import 'regenerator-runtime/runtime.js';
import { useState } from 'react';
import useAxiosSubmit from './useAxiosSubmit';

const useCreateTask = () => {
  const [createTaskhData, setCreateTaskhData] = useState();
  const [url, setUrl] = useState();
  const { response, isLoading, hasErrored, errorData } = useAxiosSubmit(url, createTaskhData);

  const createTask = async (request) => {
    setUrl(`${process.env.API_BASE_URL}/v5/Tasks`);
    setCreateTaskhData(request);
  };

  return { taskSaved: response, error: hasErrored, errorMessage: errorData, isPending: isLoading, createTask };
};

export default useCreateTask;
